import React, { useState } from "react"
import { ArrowRight, Clock } from "lucide-react"
import { useLang } from "./i18n/LangContext"

export function FinalCta() {
  const { t } = useLang()
  const [email, setEmail] = useState("")
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!email) return
    setSubmitted(true)
  }

  return (
    <section className="bg-indigo-600 dark:bg-indigo-700 py-20 sm:py-28">
      <div className="mx-auto max-w-2xl px-4 sm:px-6 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white text-balance">
          {t.cta.heading}
        </h2>
        <p className="mt-4 text-indigo-200">{t.cta.subheading}</p>

        <div className="mt-8">
          {submitted ? (
            <div className="inline-flex flex-col items-center gap-1 rounded-2xl bg-white/10 px-8 py-5 ring-1 ring-white/20">
              <span className="font-semibold text-white">{t.cta.successTitle}</span>
              <span className="text-sm text-indigo-200">{t.cta.successBody}</span>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-3">
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto w-full">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder={t.cta.emailPlaceholder}
                  className="flex-1 rounded-lg border border-indigo-400 bg-white/10 px-4 py-3 text-sm text-white placeholder:text-indigo-300 focus:outline-none focus:ring-2 focus:ring-white"
                />
                <button
                  type="submit"
                  className="inline-flex items-center justify-center gap-2 rounded-lg bg-white px-5 py-3 text-sm font-semibold text-indigo-700 hover:bg-indigo-50 active:scale-95 transition-all whitespace-nowrap"
                >
                  {t.cta.cta} <ArrowRight className="h-4 w-4" />
                </button>
              </form>
              <p className="flex items-center justify-center gap-1.5 text-xs text-indigo-300">
                <Clock className="h-3 w-3" />
                {t.cta.hint}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
